import { render, staticRenderFns } from "./CustomList.vue?vue&type=template&id=5fe1dcfe&scoped=true&"
import script from "./CustomList.vue?vue&type=script&lang=js&"
export * from "./CustomList.vue?vue&type=script&lang=js&"
import style0 from "./CustomList.vue?vue&type=style&index=0&id=5fe1dcfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe1dcfe",
  null
  
)

export default component.exports